module.exports = __webpack_public_path__ + "img/571.b95a1585.jpg";